module.exports = require("rimraf");